module.exports = __webpack_public_path__ + "static/media/badges.85b60a05.svg";